const integerFormatter = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });

/**
 * Formats a numeric value as a whole-euro string (e.g. "12.500 €").
 * Returns the fallback string when the value is null.
 *
 * @param {number|string|null} value - Amount in euros
 * @param {string} [fallback='–'] - Fallback for null
 * @returns {string}
 */
export function formatEuro(value, fallback = '–') {
	if (value === null) return fallback;
	return integerFormatter.format(Number(value)) + ' €';
}

export const formatCents = (cents) => formatEuro(cents / 100);

export const formatCount = (value) => integerFormatter.format(Number(value) || 0);
